import { jsx as r } from "react/jsx-runtime";
import { forwardRef as t } from "react";
import a from "classnames";
import '../../assets/Loader.css';const c = "_svg_176ec_2", d = {
  svg: c
}, i = t(({ size: e = 24, className: o }, s) => /* @__PURE__ */ r(
  "svg",
  {
    "data-testid": "loader",
    ref: s,
    className: a(d.svg, o),
    width: e,
    height: e,
    viewBox: "0 0 32 32",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    children: /* @__PURE__ */ r("circle", { cx: "16", cy: "16", r: "12", stroke: "currentColor", strokeWidth: "6", strokeLinecap: "round" })
  }
));
i.displayName = "Loader";
export {
  i as default
};
